/* Each gallery owns its listeners, including Theme Editor section reloads. */
if (!customElements.get('art-portfolio-gallery')) {
  customElements.define('art-portfolio-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = Array.from(this.querySelectorAll('[data-art-image]'));
      this.dialog = this.querySelector('dialog');
      this.fullImage = this.querySelector('[data-art-full]');
      this.caption = this.querySelector('[data-art-caption]');
      this.counter = this.querySelector('[data-art-counter]');
      this.more = this.querySelector('[data-art-more]');
      this.visibleCount = Number(this.dataset.batchSize) || 30;
      this.updateVisibility();
      this.more.addEventListener('click', () => {
        this.visibleCount += Number(this.dataset.batchSize) || 30;
        this.updateVisibility();
      }, options);
      this.items.forEach((item, index) => item.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.opener = item;
        this.showImage(index);
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      }, options));
      this.querySelector('[data-art-close]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('[data-art-previous]').addEventListener('click', () => this.showImage(this.currentIndex - 1), options);
      this.querySelector('[data-art-next]').addEventListener('click', () => this.showImage(this.currentIndex + 1), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showImage(this.currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.opener?.focus({ preventScroll: true });
      }, options);
      this.fullImage.addEventListener('pointerdown', event => { this.pointerStart = event.clientX; }, options);
      this.fullImage.addEventListener('pointerup', event => {
        const distance = event.clientX - this.pointerStart;
        if (Math.abs(distance) > 50) this.showImage(this.currentIndex + (distance < 0 ? 1 : -1));
        this.pointerStart = undefined;
      }, options);
      this.fullImage.addEventListener('pointercancel', () => { this.pointerStart = undefined; }, options);
    }
    updateVisibility() {
      this.items.forEach((item, index) => { item.hidden = index >= this.visibleCount; });
      this.more.hidden = this.visibleCount >= this.items.length;
    }
    showImage(index) {
      if (!this.items.length) return;
      this.currentIndex = (index + this.items.length) % this.items.length;
      const item = this.items[this.currentIndex];
      this.fullImage.src = item.href;
      this.fullImage.alt = item.dataset.caption || '';
      this.caption.textContent = item.dataset.caption || '';
      this.counter.textContent = `${this.currentIndex + 1} / ${this.items.length}`;
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow || '';
      }
      this.controller?.abort();
    }
  });
}
